export default __webpack_public_path__ + "static/media/cookie-the-pom-gySMaocSdqs-unsplash.281878ac.jpg";